import UAParser from 'ua-parser-js';

const parser = new UAParser();
const results = parser.getResult();
const os = results.os.name;

export default os;
